import { Spacer, TextLoader } from '@procurify/ui'

import { CostSummary } from '@webapp/core/components/CostSummary'
import { useProcurifyIntl } from '@webapp/hooks'
import { BudgetCategoryCardLoaderStyled } from './styles/BudgetCategoryCardLoaderStyled'
import messages from '../../messages'

export const BudgetCategoryCardLoader = () => {
  const intl = useProcurifyIntl()

  return (
    <BudgetCategoryCardLoaderStyled>
      <div>
        <TextLoader width={120} />
      </div>
      <div>
        <TextLoader height={32} width={200} />
      </div>
      <div>
        <TextLoader width={120} />
      </div>

      <Spacer />

      <CostSummary>
        <CostSummary.Cost>
          <th>{intl.formatMessage(messages.budgetLabel)}</th>
          <td>
            <TextLoader width={80} />
          </td>
        </CostSummary.Cost>
        <CostSummary.Cost>
          <th>{intl.formatMessage(messages.currentSpendLabel)}</th>
          <td>
            <TextLoader width={80} />
          </td>
        </CostSummary.Cost>
        <CostSummary.Cost>
          <th>{intl.formatMessage(messages.varianceLabel)}</th>
          <td>
            <TextLoader width={80} />
          </td>
        </CostSummary.Cost>
      </CostSummary>
    </BudgetCategoryCardLoaderStyled>
  )
}

BudgetCategoryCardLoader.displayName = 'BudgetCategoryCardLoader'
